<template>
	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="30" viewBox="0 0 30 30">
		<defs>
			<clipPath id="clip-path-RestartSvg">
				<rect id="Rectangle_14872" data-name="Rectangle 14872" width="16.592" height="15.155" fill="none" />
			</clipPath>
		</defs>
		<g id="Group_44767" data-name="Group 44767" transform="translate(-1789 -1028)">
			<rect
				id="Rectangle_14871"
				data-name="Rectangle 14871"
				width="30"
				height="30"
				rx="8"
				transform="translate(1789 1028)"
				fill="#7e7fe7"
			/>
			<g id="Group_44757" data-name="Group 44757" transform="translate(1794.704 1035.922)">
				<g id="Group_44756" data-name="Group 44756" transform="translate(0 0)" clip-path="url(#clip-path-RestartSvg)">
					<path
						id="Path_30441"
						data-name="Path 30441"
						d="M1.26,2.11l.35,2.659,1.38-1.8a7.516,7.516,0,0,1,11.7-.4l.012-.01c.063.072.114.149.174.223.091.111.18.223.265.338.11.152.212.306.309.463.068.11.137.218.2.331.1.176.182.356.265.537.035.079.082.153.115.234,0,.011,0,.023.006.034a7.623,7.623,0,0,1,.4,4.45,7.553,7.553,0,0,1-4.911,5.584l-.067.023c-.229.078-.465.136-.7.191-.084.019-.168.044-.253.06a7.6,7.6,0,0,1-6.5-1.86.633.633,0,0,1-.04-.893l0,0a.633.633,0,0,1,.894-.041,6.318,6.318,0,0,0,5.733,1.48l.058-.015c.133-.035.265-.073.394-.116.187-.06.369-.137.55-.214a6.29,6.29,0,0,0,3.14-8.485c-.027-.057-.052-.113-.08-.169A6.32,6.32,0,0,0,4,3.739l-1.38,1.8,2.656-.35a.633.633,0,0,1,.164,1.255l-4.174.549a.632.632,0,0,1-.709-.545L.006,2.275A.632.632,0,1,1,1.26,2.11"
						transform="translate(0 0)"
						fill="#fff"
					/>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'RestartSvg',
};
</script>

<style scoped lang="scss"></style>
